import { doc, updateDoc, increment } from "firebase/firestore";
import { db } from "../firebase"; 

export const Incrementread = async (uid) => {
  try {
    const postRef = doc(db, "postdata", uid);
    await updateDoc(postRef, {
      read: increment(1),
    });
      console("Read:");
  } catch (error) {
    console.error("Failed to increment read:", error.message);
  }
};